module.exports = __webpack_public_path__ + "static/media/question-mark-orange.c99f43ff.svg";